import { Component, OnDestroy, OnInit } from "@angular/core";
import { StatusListener } from "../../../status-listener";
import { AppStatus } from "../../../@models/app-status";
import { VoucherClass } from "../../../../shared-gen/Model/Vouchers/VoucherClass";
import { VoucherEvent } from "../../../../shared-gen/Model/Vouchers/VoucherEvent";
import { AppService } from "../../../services/app.service";

// Global variables to stay alive over pages
let lastVoucherEvent: VoucherEvent = null;
let lastNotificationTime = 0;

/**
 * A shortly displayed popup with a message.
 * It listens on the app status and fires whenever
 * - a voucher event was received
 * - a notification was received
 */
@Component({
	selector: "kkb-tur-notification-popup",
	templateUrl: "./tur-notification-popup.component.html",
	styleUrls: [
		"./tur-notification-popup.component.scss",
		"../../../pages/tur/tur.scss",
	],
})
export class TurNotificationPopupComponent
	extends StatusListener
	implements OnInit, OnDestroy {
	private readonly showTimeMs = 3000;

	visibility: "" | "popupVisible" | "" = "";
	voucherClass: VoucherClass = null;
	message = "";

	private closeTimer = 0;

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		const vending = status.deviceStatus.VendingStatus;
		let isNewContent = false;

		// Check if a new voucher was scanned
		const voucherEvent = vending.LastVoucher;
		if (
			false === isNewContent &&
			voucherEvent &&
			JSON.stringify(voucherEvent) !== JSON.stringify(lastVoucherEvent)
		) {
			// New voucher was scanned
			isNewContent = true;
			lastVoucherEvent = voucherEvent;
			// Show corresponding image and message
			this.voucherClass = voucherEvent.Voucher.Class;
			this.message = this.translate(
				`🌐Notification.Popup.${voucherEvent.Result}`
			).replace(
				"%voucher_name%",
				this.translate(
					"🌐Notification.Popup.Voucher." + this.voucherClass
				)
			);
		}

		// Check if there is a new notification
		const notification = vending.Notification;
		if (
			false === isNewContent &&
			notification &&
			notification.Time !== lastNotificationTime
		) {
			// There is a new notification
			isNewContent = true;
			lastNotificationTime = notification.Time;
			this.message = notification.Message;
			this.voucherClass = null;
		}

		// Update close timer
		if (isNewContent) {
			if (this.closeTimer) clearTimeout(this.closeTimer);
			this.closeTimer = window.setTimeout(() => {
				this.closePopup();
			}, this.showTimeMs);
			if (this.visibility !== "popupVisible")
				this.visibility = "popupVisible";
		}
	}

	closePopup() {
		if (this.visibility === "popupVisible") this.visibility = "";
	}

	preventBubble(event: Event = null) {
		if (event) {
			event.stopPropagation();
		}
	}
}
